import React from 'react'
import {ContainerFooterStyled} from './footerStyles'

const Footer = () => {
  return (
    <ContainerFooterStyled>Todos los derechos reservados. Copyright {new Date().getFullYear()} Iptel S.A.</ContainerFooterStyled>
  )
}

export default Footer